import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['userInfo']),
    /**
     * 是否为新添加页面
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Boolean}
     */
    isNew() {
      return this.$route.name === 'addStudent' || this.$route.name === 'addBindStudent';
    },
    isKaopei() {
      return this.$hasPermission([80, 85]);
    },
    isOptManager() {
      return this.$hasPermission(62);
    },
    canEditHopeCountry() { // 高峰
      let userArr = [
        149552, // 高峰
        146364, // 吴岛
      ];
      if (userArr.indexOf(this.userInfo.userid) > -1) {
        return true;
      }
      return false;
    },
    /**
     * 创建人为是否为当前登录者可编辑
     */
    canEditByCreator() {
      if (this.isNew) {
        return true;
      }
      return this.userInfo.userid === this.editData.custom_promoter;
    },

    /**
     * 是否为数据分析专员
     */
    isDataAnalyst() {
      return this.$hasPermission([89]); // 数据分析专员
    },

    // 是否是咨询老师
    isAdvisory() {
      return this.$hasPermission([20, 23, 27, 29, 38, 43, 54, 55, 56, 57, 71, 72, 80, 88, 124, 127, 129, 130, 131, 134, 137, 143, 147]);
    },

    /**
     * 只有前程日本老师权限
     */
    onlyQcrb() {
      return (
        this.userInfo.countries.length === 1 &&
        this.userInfo.countries.indexOf(485) > -1
      );
    },

    /**
     * 是否能编辑咨询
     */
    canEditSayer() {
      // 新马主管账号分咨询
      if ([1366711].indexOf(this.userInfo.userid) > -1) {
        return false;
      }

      // 总监和咨询主管可以变更咨询老师
      if (this.$hasPermission([22, 33, 36, 39, 42, 51, 101, 121, 122, 142, 148])) {
        return true;
      }

      if ([455174].indexOf(this.userInfo.userid) > -1) { // 唐博 常伟(455187)主管账号
        return true;
      }

      if (this.$hasPermission([122])) { // 英澳咨询组长
        return true;
      }
      if (this.isNew) {
        return true;
      }

      if (this.$hasPermission([59, 62, 98, 89, 52, 119, 126, 128, 144, 150])) { // 运营监管 芥末家主管 海外求职咨询 数据分析专员 国际预科主管 EJU主管 高考日语线上主管 高考日语线上咨询组长 东大预科主管
        return true;
      }

      if (this.infoReadOnly) {
        return false;
      }

      if (this.isSpecialRole) {
        // 特殊角色
        return true;
      }

      if (this.onlyQcrb) {
        return this.$hasPermission([39, 51]); // 前程日本{主管，咨询主管}
      }

      if (this.$isManager()) {
        return true;
      }

      if (
        this.userInfo.userid === this.is_crm_sayer_same &&
        this.$hasPermission(80)
      ) {
        // 考培
        return true;
      }

      return false;
    },
    /**
     * 是否能编辑申请
     */
    canEditApply() {
      if (this.infoReadOnly) {
        return false;
      }

      if (this.onlyQcrb) {
        return this.$hasPermission([39, 73, 43, 46]); // 主管，咨询主管,前程日本的咨询老师 角色43, 前程日本的文案老师 角色46
      }
      return true;
    },
    /**
     * 是否能编辑文书
     */
    canEditWriter() {
      if (this.onlyQcrb) {
        return this.$hasPermission([39, 153]); // 主管，文案主管
      }
      return true;
    },
    /**
     * 能否编辑客服
     */
    canEditCse() {
      if (this.onlyQcrb) {
        return this.$hasPermission([39, 74, 76, 43, 44]); // 主管，客服主管，语言学校客服主管,前程日本的咨询老师 角色43,前程日本的客服老师 角色44
      }
      return true;
    },
    /**
     * 能否编辑客户经理
     */
    canEditManager() {
      // 杨艳， 王磊-语言学校客服主管
      return (this.$hasPermission([1, 96, 99, 100]) || this.userInfo.userid === 170 || this.userInfo.userid === 190056);
    },

    managerOnlyAdmin() {
      if (this.$hasPermission(1)) {
        return false;
      }
      return true;
    },
    readOnly() {
      if (this.$hasPermission(1)) {
        return false;
      }
      const userArr = [259605, 259606, 259607, 259608, 259609,
        259610, 259611, 259612, 259614, 259615, 259616, 259617, 259618];
      if (userArr.indexOf(this.userInfo.userid) > -1) {
        return true;
      }
      if (this.isSpecialUser) {
        return true;
      }
      return this.$hasPermission([
        30, 120, // 其他 国际预科运营
        117, // 用户运营
        59, 60, 61, // 芥末家
        62, 81, 84, 85, 89, // 运营监管
        102, // 来华业务主管
        77, 104, // 渠道主管，渠道专员
        66, 67, // 合作伙伴
        69, // 市场部总监
        94, 100, // 客户经理
        96, // 英国文书主管
        167, // 业务中心市场主管
      ]);
    },
    infoReadOnly() {
      // 其他系统信息只读
      if (!this.isFibSite || this.$route.meta.readOnly) {
        return true;
      }

      let userArr = [
        259605,
        259606,
        259607,
        259608,
        259609,
        259610,
        259611,
        259612,
        259614,
        259615,
        259616,
        259617,
        259618
      ];
      if (userArr.indexOf(this.userInfo.userid) > -1) {
        return true;
      }
      if (this.$hasPermission(167, true)) {
        return true;
      }
      if (this.$hasPermission(1)) {
        return false;
      }
      if (this.is_level_lv === 66 || this.is_level_lv === 58) {
        return true;
      }
      if (this.isSnapshot) {
        return true;
      }
      if (this.isNew) {
        return false;
      }
      if (this.isKaopei && this.is_crm_sayer) {
        return true;
      }
      return this.readOnly;
    },

    /**
     * 芥末日本旧资源判断
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {bool}
     */
    isSpecialUser() {
      let userArr = [];
      if (this.$isOnline) {
        userArr = [208173, 209017, 209018, 217033];
      } else {
        userArr = [161215, 161220, 161221, 161291];
      }
      if (userArr.indexOf(this.userInfo.userid) !== -1) {
        return true;
      }
    },
    /**
     * 是否为`app分配账号` 原李青账号
     */
    isAppAlloter() {
      if (!this.$isOnline && this.$hasPermission(1)) {
        // return true;
      }
      return this.userInfo.userid === (this.$isOnline ? 813266 : 164831);
    },
  },
  methods: {
    /**
     * 根据权限判断国家是否展示
     */
    isDisabledCountry(country) {
      if ([1868, 2044].indexOf(country) > -1) { return true; }
      // if (!this.$hasPermission([149, 150, 163]) && (country === 2130 || country === 2069)) { return true; }
      if (this.infoReadOnly && !this.canEditHopeCountry) { return true; }
      return false;
    }
  },
};
